import { commonTypes } from '../common';

export const types = {
  SAVE_MAIN_ACTION_INFO_FOR_UI: 'UINEEDS/SAVE_MAIN_ACTION_INFO_FOR_UI',
  SAVE_SECONDARY_ACTION_INFO_FOR_UI: 'UINEEDS/SAVE_SECONDARY_ACTION_INFO_FOR_UI',
  SAVE_ERROR_WHEN_PRODUCT_OFFERING_CHANGED: 'UINEEDS/SAVE_ERROR_WHEN_PRODUCT_OFFERING_CHANGED',
  SET_PORTABILITY_OTP_NEEDED: "UINEEDS/SET_PORTABILITY_OTP_NEEDED",
};

export const initialState = {
  mainOptionsObj: {
    mainOptions: {},
    mainOptionSelected: null,
  },
  secondaryOptionsObj: {
    productType: null,
    secondaryOptions: {},
    secondaryOptionsSelected: [],
  },
  alreadyOwnedProductsChoicesObj: {},
  alreadyOwnedProductsChoicesSelected: [],
  cqId: null,
};

const UINeedsClientActionReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_ALREADY_OWNED_PRODUCTS_CHOICES: {
      const { alreadyOwnedProductsChoicesObj } = action.payload;

      const newState = {
        ...state,
        alreadyOwnedProductsChoicesObj,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_ALREADY_OWNED_PRODUCT_CHOICE_SELECTED: {
      const {
        groupId, id, actionId, description, phoneNumber,
      } = action.payload;
      const { alreadyOwnedProductsChoicesSelected } = state;

      let newChosenActions = [];

      if (alreadyOwnedProductsChoicesSelected) {
        newChosenActions = JSON.parse(JSON.stringify(alreadyOwnedProductsChoicesSelected));
      }

      const newChosenAction = {
        groupId,
        id,
        actionId,
        description,
        phoneNumber,
      };

      const alreadySelectedChosenAction = newChosenActions.find(chosenAction => chosenAction.groupId === groupId);

      if (alreadySelectedChosenAction) {
        const alreadySelectedChosenActionIndex = newChosenActions.indexOf(alreadySelectedChosenAction);
        newChosenActions[alreadySelectedChosenActionIndex] = newChosenAction;
      } else {
        newChosenActions.push(newChosenAction);
      }

      const newState = {
        ...state,
        alreadyOwnedProductsChoicesSelected: newChosenActions,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_SELECT_ELEMENTS_NEEDS: {
      const {
        mainOptionsForUI,
        secondaryOptionsForUI,
        productOfferingName,
        productOfferingBriefText,
        productOffering,
        productType,
        cqId,
        newActualProductOffering,
      } = action.payload;

      const { mainOptionSelected, options } = mainOptionsForUI;

      const newState = {
        ...state,
        cqId,
        productOfferingChanged: !!newActualProductOffering,
        mainOptionsObj: {
          ...state.mainOptionsObj,
          mainOptions: {
            customerQuoteItems: options,
            id: 'MAIN',
          },
          productType,
          mainOptionSelected,
        },

        secondaryOptionsObj: {
          ...state.secondaryOptionsObj,
          secondaryOptions: secondaryOptionsForUI,
        },
      };

      newState.productOffering = productOffering;

      if (!newState.productOfferingBriefText && productOfferingBriefText) {
        newState.productOfferingBriefText = productOfferingBriefText;
      }
      if (!newState.productOfferingName && productOfferingName) {
        newState.productOfferingName = productOfferingName;
      }

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SAVE_MAIN_ACTION_INFO_FOR_UI: {
      const {
        actionIdObj,
      } = action.payload;

      const newState = { ...state };

      newState.mainOptionsObj.mainOptionSelected = actionIdObj.actionId; // TODO REVISAR IMPORTANTE ANTES era = actionIdObj;
      newState.mainOptionsObj.phoneNumber = actionIdObj.phoneNumber;
      newState.mainOptionsObj.iccNumber = actionIdObj.iccNumber;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SAVE_SECONDARY_ACTION_INFO_FOR_UI: {
      const {
        newSecondaryOptionsObj,
      } = action.payload;

      const newState = { ...state };

      newState.secondaryOptionsObj = newSecondaryOptionsObj;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SAVE_ERROR_WHEN_PRODUCT_OFFERING_CHANGED: {
      const {
        errorCode,
      } = action.payload;

      const newState = { ...state };

      newState.errorOccurredWhenProductChanged = errorCode;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case commonTypes.SET_PORTABILITY_OTP_NEEDED: {
      const { otpNeeded } = action.payload;

      const newState = { ...state };

      newState.portabilityOTPNeeded = otpNeeded;

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  saveMainActionInfoForUI: actionIdObj => ({
    type: types.SAVE_MAIN_ACTION_INFO_FOR_UI,
    payload: {
      actionIdObj,
    }
  }),
  saveSecondaryActionInfoForUI: newSecondaryOptionsObj => ({
    type: types.SAVE_SECONDARY_ACTION_INFO_FOR_UI,
    payload: {
      newSecondaryOptionsObj,
    }
  }),
  saveErrorWhenProductOfferingChanged: errorCode => ({
    type: types.SAVE_ERROR_WHEN_PRODUCT_OFFERING_CHANGED,
    payload: {
      errorCode,
    }
  }),
};

export default UINeedsClientActionReducer;
